export const DEFAULT_SIZE_CHARTS_BY_TYPE = {
  garment: [
    {
      title: "Default T-Shirt Size Chart",
      unit: "in",
      locale: "en",
      is_default: true,
      sort_order: 0,
      data: {
        columns: ["Size", "Front Length (in)", "Across Shoulder (in)", "Chest (in)"],
        rows: [
          ["XS", 25.5, 16.3, 30],
          ["S", 26.5, 17.0, 32],
          ["M", 27.5, 17.8, 36],
          ["L", 28.5, 18.5, 40],
          ["XL", 29.5, 19.3, 42],
          ["XXL", 30.3, 20.0, 49],
        ],
        notes: "Measurements are approximate. Measure flat, then double for chest if required.",
      },
    },
  ],
  jewellery: [
    {
      title: "Default Ring Size Chart",
      unit: "mm",
      locale: "en",
      is_default: true,
      sort_order: 0,
      data: {
        columns: ["Size", "Inner Diameter (mm)", "Circumference (mm)"],
        rows: [
          ["US 6", 16.5, 52],
          ["US 7", 17.3, 54.3],
          ["US 8", 18.1, 56.9],
        ],
        notes: "Measure inner diameter accurately.",
      },
    },
  ],
};




